<section class="loginSection">
    <div class="login">
        <div class="">
            <div class="logo-container">
                <img  [src]="imageURL | async" alt="Active Image">
            </div>
            <div class="text-center mt-5 mb-3">
                <ng-container *ngIf="url==='change_password'">
                <h6 class="forgot-password-msg"><strong>{{'change_pwd' | translate}}</strong></h6>
            </ng-container>
            <ng-container *ngIf="url==='change_transaction_password'">
                <h6 class="forgot-password-msg"><strong>{{'change_trans_pwd' | translate}}</strong></h6>
            </ng-container>
            </div>
            <form class="form" [formGroup]="ChangePwdForm">
                <div class="col-xs-12 col-sm-12 col-md-12 ">
                    <div class="form-group mb-3">
                        <label class="fw-bold" *ngIf="url==='change_password'">{{'current_pwd' | translate}}<span
                                class="text-danger">&nbsp;*</span></label>
                        <label class="fw-bold" *ngIf="url==='change_transaction_password'">{{'current_trans_pwd' |
                            translate}}<span class="text-danger">&nbsp;*</span></label>
                        <input type="password" formControlName="currentPassword"
                            [ngClass]="{ 'is-invalid': submitted && control['currentPassword'].errors }"
                            class="form-control">
                        <div *ngIf="control['currentPassword'].errors && submitted" class="small">
                            <div *ngIf="control['currentPassword'].errors['required']"
                                class="text-danger letterspacing">
                                <span *ngIf="url==='change_password'">{{'current_pwd_required' | translate}}</span>
                                <span *ngIf="url==='change_transaction_password'">{{'current_trans_pwd_required' |
                                    translate}}</span>
                            </div>
                            <div *ngIf="control['currentPassword'].errors['pattern']" class="text-danger letterspacing">
                                {{'invalid_pwd' | translate}}</div>
                        </div>
                    </div>
                    <br>
                    <div class="form-group mb-3">
                        <label class="fw-bold" *ngIf="url==='change_password'">{{'new_pwd' | translate}}<span
                                class="text-danger">&nbsp;*</span></label>
                        <label class="fw-bold" *ngIf="url==='change_transaction_password'">{{'new_trans_pwd' |
                            translate}}<span class="text-danger">&nbsp;*</span></label>
                        <input type="password" formControlName="newPassword"
                            [ngClass]="{ 'is-invalid': submitted && control['newPassword'].errors }"
                            class="form-control">
                        <div *ngIf="control['newPassword'].errors && submitted" class="small">
                            <div *ngIf="control['newPassword'].errors['required']" class="text-danger letterspacing">
                                <span *ngIf="url==='change_password'">{{'new_pwd_required' | translate}}</span>
                                <span *ngIf="url==='change_transaction_password'"> {{'new_trns_pwd_required' |
                                    translate}}</span>
                            </div>
                            <div *ngIf="control['newPassword'].errors['pattern']" class="text-danger letterspacing">
                                {{'invalid_pwd' | translate}}</div>
                        </div>
                    </div>
                    <br>
                    <div class="form-group mb-3">
                        <label class="fw-bold" *ngIf="url==='change_password'">{{'confirm_pwd' | translate}}<span
                                class="text-danger">&nbsp;*</span></label>
                        <label class="fw-bold" *ngIf="url==='change_transaction_password'">{{'confirm_trans_pwd' |
                            translate}}<span class="text-danger">&nbsp;*</span></label>
                        <input type="password" formControlName="confirmPassword"
                            [ngClass]="{ 'is-invalid': submitted && control['confirmPassword'].errors }"
                            class="form-control">
                        <div *ngIf="control['confirmPassword'].errors && submitted" class="small">
                            <div *ngIf="control['confirmPassword'].errors['required']"
                                class="text-danger letterspacing">
                                <span *ngIf="url==='change_password'">{{'confirm_pwd_required' | translate}}</span>
                                <span *ngIf="url==='change_transaction_password'">{{'confirm_trans_pwd_required' |
                                    translate}}</span>
                            </div>
                            <div *ngIf="control['confirmPassword'].errors['pattern']" class="text-danger letterspacing">
                                {{'invalid_pwd' | translate}}</div>
                        </div>
                        <div
                            *ngIf="ChangePwdForm.errors?.passwordMismatch && (ChangePwdForm.get('confirmPassword')?.touched || submitted)">
                            <small class="text-danger" *ngIf="url==='change_password'">{{'new_pwd_not_match' |
                                translate}}</small>
                            <small class="text-danger"
                                *ngIf="url==='change_transaction_password'">{{'new_trans_pwd_not_match' |
                                translate}}</small>
                        </div>
                    </div>
                    <div class="text-center mt-3">
                        <button type="submit" class="btn btn-cancel me-2 my-1 submit-button"  (click)="back()"><em class="fa fa-arrow-left"></em>&nbsp; {{'back' | translate}}</button>
                        <button class="btn btnc btnc me-1" (click)="onSubmit(url)"><em class="fa fa-check-circle"></em>
                            {{
                            'SUBMIT' | translate }}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>

</section>